import {Component, OnInit, OnChanges } from '@angular/core';
import {Input} from '@angular/core';
import {EventEmitter} from '@angular/core';
import {Output} from '@angular/core';
import {SimpleChanges} from '@angular/core';
import {Listing} from '../../../../classes/listing';
import {DeviceService} from '../../../../services/device/device.service';
import {ListingsService} from '../../../../services/listings.service';
import {PreferencesService} from '../../../../services/preferences.service';
import {ADD_SAVED_LISTING_PAGE_GTM, ADD_SAVED_LANDING_PAGE_GTM} from '../../../../classes/analytics-tags';
import { BritishColumbiaStateShort } from '../../../../app-config.constants';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment-wrapper';


@Component({
  selector: 'app-listing-summary-desktop-content',
  templateUrl: './listing-summary-desktop-content.component.html',
  styleUrls: ['./listing-summary-desktop-content.component.scss']
})
export class ListingSummaryDesktopContentComponent implements OnInit, OnChanges {
  @Input() listing: Listing;
  @Input() isLandingPageListing: boolean = false;
  @Input() disableSellersLeadForm: boolean = false;
  @Output() toggleExpandedGalleryView: EventEmitter<boolean> = new EventEmitter();
  @Output() changeCarouselIndex: EventEmitter<number> = new EventEmitter();
  @Input() currentSlideIndex: number = 0;
  @Input() forceLuxuryStyle: boolean = false;
  @Input() sessionEmail: string;
  @Input() showMap: boolean;
  @Input() readonly isMortgageApplicable: boolean = false;
  @Input() showContactAgent: boolean = true;
  @Input() showScheduleViewing: boolean = true;
  @Input() showViewListingDetails: boolean = false;
  @Input() mortgagePaymentAmount: number = 0;
  @Output() showContactAgentClicked: EventEmitter<any> = new EventEmitter();
  @Output() showScheduleViewingClicked: EventEmitter<any> = new EventEmitter();
  @Output() homeEstimateLinkClick: EventEmitter<any> = new EventEmitter();
  @Output() showOffmarketCTAClicked: EventEmitter<any> = new EventEmitter();
  priceOrPricePerSqFt: string;
  saveListingText = '';
  BritishColumbiaStateShort = BritishColumbiaStateShort;
  readonly cdnUrl = environment.cdnServerUrl;
  showEmailModal = false;
  isDropdownOpen = false;
  showRequestSent = false;
  constructor(private deviceService: DeviceService,
              private preferencesService: PreferencesService,
              private listingService: ListingsService,
              private router: Router
            ) { }

  ngOnInit() {
    this.setPriceOrPricePerSqFt();
    this.saveListingText = 'listing-summary.' + (this.listing.isFavourite ? 'saved-saved-listings' : 'save-saved-listings');
    if (this.listing &&
        this.listing.city &&
        this.listing.area &&
        this.listing.city.toLowerCase() === this.listing.area.toLowerCase())
    {
      this.listing.area = null
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.listing) {
      this.setPriceOrPricePerSqFt();
    }
  }

  openPrintListingPage() {
    this.isDropdownOpen = false;
    // this.router.navigate([]).then(
    //   result => {
        window.open('/print-listing/' + this.listing.listingId, '_blank');
      //}
    //);
  }

  setPriceOrPricePerSqFt() {
    this.listingService.getPriceOrPricePerSqFtString(this.listing).subscribe(str => this.priceOrPricePerSqFt = str);
  }

  toggleFavourite($event) {
    this.isDropdownOpen = false;
    $event.stopPropagation();
    this.listing.isFavourite = !this.listing.isFavourite;
    this.preferencesService.toggleFavouriteListing(this.listing.listingId, this.isLandingPageListing ? ADD_SAVED_LANDING_PAGE_GTM : ADD_SAVED_LISTING_PAGE_GTM);
    this.listing.getFavouriteIconToUse();
    this.saveListingText = 'listing-summary.' + (this.listing.isFavourite ? 'saved-saved-listings' : 'save-saved-listings');
  }

  openPopup(url, title) {
    window.open(url, `${title} Share listing`, `height=450, width=550, top=${window.innerHeight / 2 - 275}, left=${(window.innerWidth / 2) - 225},toolbar=0, location=0, menubar=0, directories=0, scrollbars=0 `)
  }

  navigateToForm() {
    this.toggleExpandedGalleryView.emit(false);
    // if (this.listing.isLuxury || this.listing.isCommercial) {
      this.showContactAgentClicked.emit();
    // } else {
    //   // TODO: make this smooth
    //   const top = document.getElementById('contact-form').offsetTop;
    //   // TODO: make the first input focused on the contact form
    //   document.getElementById('contact-form').scrollIntoView(true);
    // }
  }

  navigateToScheduleForm () {
    this.toggleExpandedGalleryView.emit(false);
    this.showScheduleViewingClicked.emit();
  }

  navigateToOffmarketForm() {
    this.toggleExpandedGalleryView.emit(false);
    this.showOffmarketCTAClicked.emit();
  }
}
